import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-3 mt-3 mb-3" }
const _hoisted_2 = { class: "flex gap-3" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block mb-1 text-color text-base"
}, "Contact Name", -1)
const _hoisted_5 = { class: "p-input-icon-left w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block mb-1 text-color text-base"
}, "Phone Number", -1)
const _hoisted_8 = { class: "p-input-icon-left w-full" }
const _hoisted_9 = { class: "w-half flex align-items-end justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_InputText, {
            name: "name",
            type: "text",
            modelValue: _ctx.contactName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactName) = $event)),
            class: "w-full",
            id: "name",
            placeholder: "John Doe",
            required: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_InputMask, {
            id: "phone",
            modelValue: _ctx.contactPhoneNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactPhoneNumber) = $event)),
            mask: "(999) 999-9999",
            class: "w-full",
            placeholder: "(999) 999-9999",
            required: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = $event => _ctx.addContact(_ctx.contactInfo)),
          icon: "pi pi-plus",
          disabled: !_ctx.contactInfo.name.value && !_ctx.contactInfo.phoneNumber.value,
          text: "",
          rounded: ""
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}